import {
  Backend,
  getNearbyQueryParamValue,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { SearchActiveProjectsCollection } from './search-active-projects.types';

export function searchActiveProjectsBackend(): Backend<
  SearchActiveProjectsCollection
> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    }, // This endpoint is only used with search queries so doesn't need an ordering

    fetch: (authUid, ids, query, order) => {
      const searchCoordinates = getNearbyQueryParamValue(
        query,
        'searchCoordinates',
      );

      return {
        endpoint: `projects/0.1/projects/active`,
        params: {
          // Projections
          full_description: 'true',
          job_details: 'true',
          location_details: 'true',
          upgrade_details: 'true',

          // Filters
          countries: getQueryParamValue(query, 'country').map(
            country => country?.code,
          ),
          jobs: getQueryParamValue(query, 'skillIds')[0],
          latitude: searchCoordinates?.latitude,
          longitude: searchCoordinates?.longitude,
          offset: query?.searchQueryParams?.offset,
          query: query?.searchQueryParams?.query || query?.searchQueryParams?.q,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
